import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "page-content" }
const _hoisted_2 = { class: "recharge-amount" }
const _hoisted_3 = { class: "amount" }
const _hoisted_4 = { class: "payment-methods" }
const _hoisted_5 = { class: "method-list" }
const _hoisted_6 = { class: "bank-pay" }
const _hoisted_7 = { class: "method-item" }
const _hoisted_8 = { class: "bank-select" }
const _hoisted_9 = { class: "bottom-section" }
const _hoisted_10 = { class: "service" }
const _hoisted_11 = { class: "drawer-content" }
const _hoisted_12 = { class: "drawer-header" }
const _hoisted_13 = { class: "bank-list" }
const _hoisted_14 = ["onClick"]
const _hoisted_15 = { class: "bank-info" }
const _hoisted_16 = { class: "bank-detail" }
const _hoisted_17 = { class: "bank-name" }
const _hoisted_18 = { class: "card-no" }

import { ref, onMounted } from 'vue';
import CustomTitleBar from "@/components/CustomTitleBar/index.vue";
import { useRouter, useRoute } from 'vue-router';
import { getCardList, pay } from '@/api/wallet';
import { showToast } from 'vant';

export default /*@__PURE__*/_defineComponent({
  __name: 'pay',
  setup(__props) {

const router = useRouter();
const route = useRoute();
const amount = ref('');
const goodsId = ref('');
const goodsTitle = ref('');

const payMethod = ref('alipay');
const payMethodMap = {
  alipay: 1,
  wechat: 2,
  bank: 0
}

const cardList = ref<any[]>([]);
const cardInfo = ref<any>({});

const showDrawer = ref(false);

const handleRecharge = () => {
  //表单校验
  if (!amount.value) {
    showToast('请输入支付金额');
    return;
  }
  if (payMethod.value === 'bank' && !cardInfo.value.linkId) {
    showToast('请选择银行卡');
    return;
  }
  // 处理支付逻辑
  console.log('参数:', amount.value, cardInfo.value.linkId, payMethodMap[payMethod.value as keyof typeof payMethodMap]);
  pay({
    amount: amount.value,
    goodsId: goodsId.value,
    goodsTitle: goodsTitle.value,
    linkId: cardInfo.value.linkId,
    remark: '',
    type: payMethodMap[payMethod.value as keyof typeof payMethodMap]
  }).then((res) => {
    if (res.code === 200) {
      //打开支付页面
      window.open(res.data.pageUrl, '_blank');
    }
  })
};

// 切换支付方式
const payMethodChange = (method: string) => {
  payMethod.value = method;
}

const handleAddBank = () => {
  router.push('/BankCard');
};

// 切换银行卡
const handleChangeBank = (e: Event) => {
  e.stopPropagation(); // 阻止冒泡
  showDrawer.value = true;
}

// 添加选择银行卡方法
const selectBank = (card: any) => {
  cardInfo.value = {
    linkId: card.linkId,
    bankName: card.bankName,
    bankAccountNo: card.bankAccountNo.slice(-4)
  }
  showDrawer.value = false;
  payMethod.value = 'bank';
}

//获取银行卡列表
const getList = async () => {
  const res = await getCardList().then((res) => {
    if (res.code === 200) {
      cardList.value = res.data
      if (cardList.value.length > 0) {
        cardInfo.value = {
          linkId: cardList.value[0].linkId,
          bankName: cardList.value[0].bankName,
          bankAccountNo: cardList.value[0].bankAccountNo.slice(-4)
        }
      } else {
        cardInfo.value = {
          linkId: null,
          bankName: null,
          bankAccountNo: null
        }
      }
    }
  })
}

onMounted(() => {
  if (route.query.amount) {
    amount.value = route.query.amount as string;
  }
  if (route.query.goodsId) {
    goodsId.value = route.query.goodsId as string;
  }
  if (route.query.goodsTitle) {
    goodsTitle.value = route.query.goodsTitle as string;
  }
  getList()
})

return (_ctx: any,_cache: any) => {
  const _component_svgIcon = _resolveComponent("svgIcon")!
  const _component_van_popup = _resolveComponent("van-popup")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(CustomTitleBar, { title: "支付" }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _cache[8] || (_cache[8] = _createElementVNode("div", { class: "label" }, "支付金额", -1)),
        _createElementVNode("div", _hoisted_3, [
          _cache[7] || (_cache[7] = _createElementVNode("span", { class: "currency" }, "¥", -1)),
          _withDirectives(_createElementVNode("input", {
            type: "number",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((amount).value = $event)),
            placeholder: "请输入支付金额",
            readonly: ""
          }, null, 512), [
            [_vModelText, amount.value]
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _cache[13] || (_cache[13] = _createElementVNode("div", { class: "label" }, "支付方式", -1)),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", {
            class: "method-item",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (payMethodChange('alipay')))
          }, [
            _createVNode(_component_svgIcon, {
              name: "alipay",
              size: "20"
            }),
            _cache[9] || (_cache[9] = _createElementVNode("span", null, "支付宝", -1)),
            _createVNode(_component_svgIcon, {
              name: payMethod.value === 'alipay' ? 'selected' : 'select',
              size: "20"
            }, null, 8, ["name"])
          ]),
          _createElementVNode("div", {
            class: "method-item",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (payMethodChange('wechat')))
          }, [
            _createVNode(_component_svgIcon, {
              name: "wechat",
              size: "20"
            }),
            _cache[10] || (_cache[10] = _createElementVNode("span", null, "微信", -1)),
            _createVNode(_component_svgIcon, {
              name: payMethod.value === 'wechat' ? 'selected' : 'select',
              size: "20"
            }, null, 8, ["name"])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_component_svgIcon, {
                name: "bankcard",
                size: "20"
              }),
              _cache[11] || (_cache[11] = _createElementVNode("span", null, "银行卡支付", -1))
            ]),
            _createElementVNode("div", _hoisted_8, [
              (cardInfo.value.bankName)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: "selected-bank",
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (payMethodChange('bank')))
                  }, [
                    _createElementVNode("span", null, [
                      _createTextVNode(_toDisplayString(cardInfo.value.bankName) + " (" + _toDisplayString(cardInfo.value.bankAccountNo) + ") ", 1),
                      _createElementVNode("span", {
                        class: "change-bank",
                        onClick: handleChangeBank
                      }, "切换")
                    ]),
                    _createVNode(_component_svgIcon, {
                      name: payMethod.value === 'bank' ? 'selected' : 'select',
                      size: "20"
                    }, null, 8, ["name"])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", {
                class: "add-bank",
                onClick: handleAddBank
              }, [
                _cache[12] || (_cache[12] = _createTextVNode("添加银行卡 ")),
                _createVNode(_component_svgIcon, {
                  name: "arrow_right",
                  size: "10"
                })
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          _cache[14] || (_cache[14] = _createTextVNode(" 如有疑问联系客服: ")),
          _createElementVNode("span", {
            onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.handleHelpClick && _ctx.handleHelpClick(...args)))
          }, "客服")
        ]),
        _createElementVNode("button", {
          class: "recharge-btn",
          onClick: handleRecharge
        }, "支付"),
        _cache[15] || (_cache[15] = _createElementVNode("div", { class: "agreement" }, [
          _createTextVNode(" 支付即代表同意"),
          _createElementVNode("span", null, "《鲸宝支付协议》")
        ], -1))
      ])
    ]),
    _createVNode(_component_van_popup, {
      show: showDrawer.value,
      "onUpdate:show": _cache[6] || (_cache[6] = ($event: any) => ((showDrawer).value = $event)),
      position: "bottom",
      round: "",
      style: { height: '60%' }
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            _cache[16] || (_cache[16] = _createElementVNode("span", null, "选择银行卡", -1)),
            _createElementVNode("span", {
              class: "close-icon",
              onClick: _cache[5] || (_cache[5] = ($event: any) => (showDrawer.value = false))
            }, [
              _createVNode(_component_svgIcon, {
                name: "close",
                size: "20"
              })
            ])
          ]),
          _createElementVNode("div", _hoisted_13, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(cardList.value, (card) => {
              return (_openBlock(), _createElementBlock("div", {
                key: card.id,
                class: "bank-item",
                onClick: ($event: any) => (selectBank(card))
              }, [
                _createElementVNode("div", _hoisted_15, [
                  _createVNode(_component_svgIcon, {
                    name: "bankcard",
                    size: "20"
                  }),
                  _createElementVNode("div", _hoisted_16, [
                    _createElementVNode("div", _hoisted_17, _toDisplayString(card.bankName), 1),
                    _createElementVNode("div", _hoisted_18, _toDisplayString(card.bankAccountNo), 1)
                  ])
                ]),
                _createVNode(_component_svgIcon, {
                  name: cardInfo.value.linkId === card.linkId ? 'selected' : 'select',
                  size: "20"
                }, null, 8, ["name"])
              ], 8, _hoisted_14))
            }), 128))
          ])
        ])
      ]),
      _: 1
    }, 8, ["show"])
  ], 64))
}
}

})